module.exports = __webpack_public_path__ + "img/cross.1c5754bf.svg";